import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { EventBus } from '@blade/common';
import RoleAdd from './role-add.vue';
let default_1 = class default_1 extends Vue {
    isFullscreen;
    addDialogVisible = false;
    searchValue = '';
    statusValue = '';
    initRoles = [];
    options = ['ENABLE', 'DISABLE'];
    get url() {
        const res = !this.isFullscreen ? require('@blade/common/assets/svgs/enlarge.svg') : require('@blade/common/assets/svgs/narrow.svg');
        return res;
    }
    handleFullScreen() {
        this.$emit('onFullScreen');
    }
    handleRefresh() {
        this.$emit('onRefresh');
    }
    addRoles() {
        this.addDialogVisible = true;
        this.$parent.openMode = 'add';
    }
    // 模糊搜索
    dimSearch(value) {
        this.$parent.getData({ state: this.statusValue, keyWords: value });
    }
    // 更改状态
    changState(value) {
        this.$parent.getData({ state: value, keyWords: this.searchValue });
    }
    mounted() {
        EventBus.$on('getInitRoles', (data) => {
            this.initRoles = data;
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "isFullscreen", void 0);
default_1 = __decorate([
    Component({
        name: 'RoleHeader',
        components: { AuthItem, RoleAdd },
        i18n: {
            messages: {
                'en-us': {
                    roleLists: 'Role List',
                    create: 'Add Role',
                    search: 'Search',
                    status: 'Status',
                },
                zh: {
                    roleLists: '角色列表',
                    create: '创建角色',
                    search: '搜索',
                    status: '状态',
                },
            },
        },
    })
], default_1);
export default default_1;
